__turbopack_context__.v({
  "item": "-z5SuW_item",
  "list": "-z5SuW_list",
});
